import { create } from 'zustand'

interface State {
    indexTab: number
    setIndexTab: (index: number) => void
}

export const useNavigateTabsStore = create<State>((set) => ({
  indexTab: 1,
  setIndexTab: (index) => set({ indexTab: index }),
}))